import type {
  ProposalBatch,
  ProposalBatchStatus,
} from "@stockline/shared/types/ai/proposal"
import { PROPOSAL_BATCH_TABLE } from "../../../lib/offline/resources/ai/proposal-batch/db"
import { useAISync } from "../providers/AISyncProvider"

export interface UseProposalBatchesFilter {
  status?: ProposalBatchStatus
}

export function useProposalBatches(
  filter?: UseProposalBatchesFilter
): ProposalBatch[] {
  const { reactive } = useAISync()
  return reactive.useQuery<ProposalBatch>(PROPOSAL_BATCH_TABLE, {
    ...filter,
    orderBy: "-createdAt",
  })
}

export function usePendingProposalBatches(): ProposalBatch[] {
  return useProposalBatches({ status: "pending" })
}
